var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "library-card",
      on: { mouseover: _vm.handleCardOver, mouseleave: _vm.handleCardLeave }
    },
    [
      _c(
        "div",
        _vm._g(
          {
            staticClass: "card-ad-container",
            class: { clickable: _vm.advertisement.link }
          },
          _vm.advertisement.link ? { click: _vm.goToAdLink } : {}
        ),
        [
          _c("div", {
            staticClass: "card-ad-img",
            style: {
              "background-image": "url('" + _vm.advertisement.image_url + "')"
            }
          }),
          _vm._v(" "),
          _vm.mouseOver && _vm.advertisement.link
            ? _c("div", { staticClass: "card-ad-background" })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-cover-img-thumb clickable" }),
      _vm._v(" "),
      _c("div", { staticClass: "card-block clickable" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 card-info-section" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h4", { staticClass: "card-title" }),
              _vm._v(" "),
              _c("div", { staticClass: "card-subtitle typography--caption" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-bottom-desc" }, [
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _c("span", { staticStyle: { color: "transparent" } }, [
                      _vm._v(" ")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [_vm._v(" ")]
                )
              ]),
              _vm._v(" "),
              _vm.showOwner
                ? _c("div", [
                    _c(
                      "small",
                      {
                        staticClass:
                          "typography--caption typography--color-secondary"
                      },
                      [_vm._v(" ")]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59150641", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59150641","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/library/components/AdCard.vue
// module id = 78ju
// module chunks = 1